import { showLoading, hideLoading } from 'react-redux-loading-bar'

import { getUrl } from './utils/network'

export const SHOW_SIDE_VIEW = 'SHOW_SIDE_VIEW'
export const HIDE_SIDE_VIEW = 'HIDE_SIDE_VIEW'
export const SHOW_THUMB_VIEW =  'SHOW_THUMB_VIEW'
export const HIDE_THUMB_VIEW = 'HIDE_THUMB_VIEW'
export const SHOW_ZOOM_AREA = 'SHOW_ZOOM_AREA'
export const HIDE_ZOOM_AREA = 'HIDE_ZOOM_AREA'
export const ZOOM_IN = 'ZOOM_IN'
export const ZOOM_OUT = 'ZOOM_OUT'
export const WINDOW_SIZE = 'WINDOW_SIZE'
export const CALC_DOCUMENT_RATIO = 'CALC_DOCUMENT_RATIO'
export const USER_AGENT = 'USER_AGENT'
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'

export const REQUEST_POSTS = 'REQUEST_POSTS'
export const RECEIVE_POSTS = 'RECEIVE_POSTS'
export const MOVE_PAGE = 'MOVE_PAGE'
export const CHECK_PASSWORD = 'CHECK_PASSWORD'
export const SHOW_INPUT_META = 'SHOW_INPUT_META'
export const HIDE_INPUT_META = 'HIDE_INPUT_META'

function showSideView() {
    return {
        type: SHOW_SIDE_VIEW
    }
}

function hideSideView() {
    return {
        type: HIDE_SIDE_VIEW
    }
}

export function toggleSideView() {
    return (dispatch, getState) => {
        const isShow = getState().extra.showSideView
        if (isShow) {
            dispatch(hideSideView())
        } else {
            dispatch(showSideView())
            dispatch(hideThumbView())
        }
    }
}

function showThumbView() {
    return {
        type: SHOW_THUMB_VIEW
    }
}

function hideThumbView() {
    return {
        type: HIDE_THUMB_VIEW
    }
}

export function toggleThumbView() {
    return (dispatch, getState) => {
        const isShow = getState().extra.showThumbView
        if (isShow) {
            dispatch(showZoomArea())
            dispatch(hideThumbView())
        } else {
            dispatch(showThumbView())
            dispatch(hideSideView())
            dispatch(hideZoomArea())
        }
    }
}

function zoomInIncrement(increment) {
    return {
        type: ZOOM_IN,
        increment: increment,
    }
}

export function zoomIn() {
    return (dispatch, getState) => {
        const { showRatio } = getState().extra

        if (showRatio < 1.0) {
            dispatch(zoomInIncrement(0.1))
        } else if (showRatio < 3.0) {
            dispatch(zoomInIncrement(0.5))
        }
    }
}

function zoomOutDecrement(decrement) {
    return {
        type: ZOOM_OUT,
        increment: decrement
    }
}

export function zoomOut() {
    return (dispatch, getState) => {
        const { showRatio } = getState().extra

        if (showRatio > 1.0) {
            dispatch(zoomOutDecrement(0.5))
        } else if (showRatio >= 0.6) { // > 0.5) {
            dispatch(zoomOutDecrement(0.1))
        }
    }
}

function showZoomArea() {
    return {
        type: SHOW_ZOOM_AREA
    }
}

function hideZoomArea() {
    return {
        type: HIDE_ZOOM_AREA
    }
}

export function setWindowSize(info) {
    return {
        type: WINDOW_SIZE,
        size: info,
    }
}

function calcDocRatio(info) {
    return {
        type: CALC_DOCUMENT_RATIO,
        size: info
    }
}

export function setUserAgent(ua) {
    return {
        type: USER_AGENT,
        ua: ua,
    }
}

export function showNotification(noti) {
    return {
        type: SHOW_NOTIFICATION,
        noti: noti,
    }
}

export function showInputMeta(index, type) {
    return {
        type : SHOW_INPUT_META,
        metaIndex : index,
        metaType : type
    }
}

export function hideInputMeta() {
    return {
        type : HIDE_INPUT_META,
    }
}


function checkPassword() {
    return {
        type: CHECK_PASSWORD,
    }
}

function movePage(index) {
    return {
        type: MOVE_PAGE,
        index: index,
    }
}

function requestPosts(command) {
    return {
        type: REQUEST_POSTS,
        command
    }
}

function receivePosts(command, json) {
    return {
        type: RECEIVE_POSTS,
        command,
        posts: json.result,
        status: json.status,
        receiveAt: Date.now(),

    }
}

function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
    } else {
        byteString = unescape(dataURI.split(',')[1]);
    }

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var arrayBuffer = new ArrayBuffer(byteString.length)
    var intArray = new Uint8Array(arrayBuffer)

    for (var i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
    }

    return new Blob([intArray], {type:mimeString});
}

function fetchUrl(command, data, fileName) {
    let formData = new FormData()

    if (fileName !== undefined) {
        formData.append("handle", data.handle)
        formData.append("index", data.index)
        if (data.file instanceof File) {
            formData.append("file", data.file, fileName)
        } else {
            formData.append("file", dataURItoBlob(data.file), fileName)
        } 
    }

    return fetch(getUrl('/' + command), fileName === undefined ? {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
    } : {
        method: 'POST',
        body: formData,
    })
}

function asyncFetch(command, data, fileName=undefined) {
    return (dispatch, getState) => {
        dispatch(showLoading())
        dispatch(requestPosts(command))

        return fetchUrl(command, data, fileName)
            .then(response => response.json())
            .then(json => {
                dispatch(hideLoading())

                if (json.status === 200) {
                    if (json.result.cd !== '0000') {
                        dispatch(showNotification({
                            title: command,
                            message: `${json.result.msg}(${json.result.cd})`,
                            level: 'error',
                        }))
                    }
                    dispatch(receivePosts(command, json))
                } else {
                    dispatch(receivePosts(command, json))
                    dispatch(showNotification({
                        title: 'http response error',
                        message: `http status code ${json.status}`,
                        level: 'error',
                    }))
                }
            })
    }
}

function shouldFetchPosts(state, command) {
    const posts = state.viewer[command]

    if (!posts) {
        return true
    } else if (posts.isFetching) {
        return false
    } else {
        return true
    }
}

export function asyncFetchIfNeed(command, data, isForce=false) {
    return (dispatch, getState) => {
        if (isForce || shouldFetchPosts(getState(), command)) {
            return dispatch(asyncFetch(command, data))
        }
    }
}

export function open(url) {
    return (dispatch, getState) => {
        return dispatch(asyncFetchIfNeed('open', {fileUrl: url}))
            .then(() => {
                const { openStatus } = getState().viewer
                if ( openStatus.fileInfo !== undefined && !openStatus.fileInfo.lockPassword ) {
                    dispatch(getPageInfo())
                        .then(() => {
                            dispatch(getPageImage(0))
                            dispatch(getThumbnailImage(0))
                        })
                    dispatch(getMetaInfo())
                }
            })
    }
}

export function close() {
    return (dispatch, getState) => {
        const { openStatus } = getState().viewer
        return dispatch(asyncFetchIfNeed('close', {
            handle: openStatus.fileInfo.handle,
        }))
    }
}

export function sendPassword(password) {
    return (dispatch, getState) => {
        const { openStatus } = getState().viewer
        return dispatch(asyncFetchIfNeed('inputPassword', {
            handle: openStatus.fileInfo.handle,
            password: password,
        }))
            .pipe(() => {
                const { openStatus } = getState().viewer
                if ( !openStatus.fileInfo.lockPassword ) {
                    dispatch(getPageInfo())
                        .then(() => {
                            dispatch(getPageImage(0))
                            dispatch(getThumbnailImage(0))
                        })
                    dispatch(getMetaInfo())
                } else {
                    dispatch(checkPassword())
                }
            })
    }
}

export function getPageInfo() {
    return (dispatch, getState) => {
        const { openStatus } = getState().viewer
        return dispatch(asyncFetch('pageInfo', {
            handle: openStatus.fileInfo.handle,
            zoomRatio: 100,
        }))
            .then(() => {
                const { openStatus } = getState().viewer
                dispatch(calcDocRatio(openStatus.pageInfo.data.pageSize))
            })
    }
}

export function getMetaInfo() {
    return (dispatch, getState) => {
        const { openStatus } = getState().viewer
        return dispatch(asyncFetchIfNeed('metaInfo', {
            handle: openStatus.fileInfo.handle,
        }))
    }
}

export function getPageImage(index) {
    return (dispatch, getState) => {
        const { userAgent } = getState().extra
        let isMobile = userAgent.mobile() === null ? false : true
        const { openStatus } = getState().viewer
        const { w, h } = openStatus.pageInfo.data.pageSize
        return dispatch(asyncFetchIfNeed('pageImage', {
            handle: openStatus.fileInfo.handle,
            imageWidth: isMobile ? w : w*3,
            imageHeight: isMobile ? h : h*3,
            zoomRatio: isMobile ? 100 : 100*3,
            pageIndex: index,
        }, true))
    }
}

export function getThumbnailImage(index) {
    return (dispatch, getState) => {
        const { openStatus } = getState().viewer
        const totalPage = openStatus.pageInfo.data.pageCount
        let start = index <= 4 ? 0 : index-4
        let end = index + 5 >= totalPage ? totalPage-1 : index+4
        return dispatch(asyncFetchIfNeed('thumbnail', {
            handle: openStatus.fileInfo.handle,
            zoomRatio: 50,
            start_page: start,
            end_page: end,
        }, true))
    }
}

export function setSoundMeta(metaIndex, sound) {
    return (dispatch, getState) => {
        const { openStatus } = getState().viewer
        if (sound.name !== undefined) {
            return dispatch(asyncFetch('setSoundMeta', {
                handle: openStatus.fileInfo.handle,
                index: metaIndex,
                file: sound,
                }, sound.name))
                .then(() => {dispatch(getMetaInfo())})
        } else {
                return dispatch(asyncFetch('setSoundMeta', {
                handle: openStatus.fileInfo.handle,
                index: metaIndex,
                file: sound,
                }, 'voice.wav'))
                .then(() => {dispatch(getMetaInfo())})
        }

    }
}

export function setTextMeta(metaIndex, text) {
    return (dispatch, getState) => {
        const { openStatus } = getState().viewer
        return dispatch(asyncFetch('setTextMeta', {
            handle: openStatus.fileInfo.handle,
            index: metaIndex,
            str: text,
        }))
            .then(() => {dispatch(getMetaInfo())})
    }
}

export function setSignMeta(metaIndex, sign) {
    return (dispatch, getState) => {
        const { openStatus } = getState().viewer
        return dispatch(asyncFetch('setSignMeta', {
            handle: openStatus.fileInfo.handle,
            index: metaIndex,
            file: sign,
        }, "sign.png"))
            .then(() => {dispatch(getMetaInfo())})
    }
}

export function setImageMeta(metaIndex, image) {
    return (dispatch, getState) => {
        const { openStatus } = getState().viewer
        return dispatch(asyncFetch('setImageMeta', {
            handle: openStatus.fileInfo.handle,
            index: metaIndex,
            file: image,
        }, image.name))
            .then(() => {dispatch(getMetaInfo())})
    }
}

export function setCheckMeta(metaIndex, checked) {
    return (dispatch, getState) => {
        const { openStatus } = getState().viewer
        return dispatch(asyncFetch('setCheckboxMeta', {
            handle: openStatus.fileInfo.handle,
            index: metaIndex,
            value: checked,
        }))
            .then(() => {dispatch(getMetaInfo())})
    }
}

export function setRadioMeta(metaIndex, group) {
    return (dispatch, getState) => {
        const { openStatus } = getState().viewer
        return dispatch(asyncFetch('setRadioMeta' , {
            handle: openStatus.fileInfo.handle,
            pageIndex : openStatus.current.data.pageIndex,
            child_index: metaIndex,
            parent_index: group
        }))
            .then(() => {dispatch(getMetaInfo())})
    }
}

export function movePageIndex(index) {
    return (dispatch, getState) => {
        dispatch(getPageImage(index))
        dispatch(getThumbnailImage(index))
        return dispatch(movePage(index))
    }
}



// WEBPACK FOOTER //
// ./src/actions.js